import { Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '../services/i18n.service';

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private i18nService: I18nService) {}

  transform(key: string, fallback?: string): string {
    if (!key) return fallback || '';
    const res = this.i18nService.t(key, fallback);
    return (res && res.trim().length > 0) ? res : (fallback || key);
  }
}
